import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as TyreActions from './tyre.action';
import { TyreService } from './tyre.service';
import { BannerService } from '../../shared/services/banner.service';

import * as SeasonsModels from '../../models/tyre/seasons';
import * as BrandsModels from '../../models/tyre/brands';
import * as TyreCarTypesModels from '../../models/tyre/tyreCarTypes';
import * as TyreSegmentsModels from '../../models/tyre/tyreSegments';
import * as TyreParametersModels from '../../models/tyre/tyreParameters';
import * as TyrePreviewModels from '../../models/tyre/tyrePreview';
import * as TyreOfferApiModels from '../../models/tyre/tyreOfferApi';

import * as Models from '../../models/commonModels';
import * as TyreParamiterModels from '../../models/tyre/tyreParameters';

import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { SaveState } from '../../models/commonModels';
import { TyreSearchModel } from '../../models/tyre/tyreSearch';
import { StorageService } from '../../shared/services/storage.service';

export interface TyreStateModel {
  SeasonsDictionaryList: SeasonsModels.SeasonsDictionaryListModel;
  BrandDictionaryList: BrandsModels.BrandsDictionaryListModel;
  TyreCarTypeDictionaryList: TyreCarTypesModels.TyreCarTypesDictionaryListModel;
  TyreSegmentDictionaryList: TyreSegmentsModels.TyreSegmentsDictionaryListModel;
  TyreParameters: TyreParametersModels.TyreParametersObjectModel;
  TyreAvailableForSaleParameters: TyreParametersModels.TyreParametersObjectModel;
  TyrePreviewList: TyrePreviewModels.TyrePreviewListModel;
  RimDictionary: Models.Response<TyrePreviewModels.TyrePreviewModel[]>;

  TyreWidthList: Models.ResponseList<TyreParamiterModels.TyreWidthModel>,
  TyreWidth: Models.Response<TyreParamiterModels.TyreWidthModel>,

  TyreHeightList: Models.ResponseList<TyreParamiterModels.TyreHeightModel>,
  TyreHeight: Models.Response<TyreParamiterModels.TyreHeightModel>,

  TyreDiameterList: Models.ResponseList<TyreParamiterModels.TyreDiameterModel>,
  TyreDiameter: Models.Response<TyreParamiterModels.TyreDiameterModel>,

  TyreConstructionTypeList: Models.ResponseList<TyreParamiterModels.TyreConstructionTypeModel>,
  TyreConstructionType: Models.Response<TyreParamiterModels.TyreConstructionTypeModel>,

  TyreSpeedIndexeList: Models.ResponseList<TyreParamiterModels.TyreSpeedIndexModel>,
  TyreSpeedIndexe: Models.Response<TyreParamiterModels.TyreSpeedIndexModel>,

  TyreLoadIndexeList: Models.ResponseList<TyreParamiterModels.TyreLoadIndexModel>,
  TyreLoadIndexe: Models.Response<TyreParamiterModels.TyreLoadIndexModel>,

  TyreReinforcementList: Models.ResponseList<TyreParamiterModels.TyreReinforcementModel>,
  TyreReinforcements: Models.Response<TyreParamiterModels.TyreReinforcementModel>

  BrandList: Models.ResponseList<TyreParamiterModels.BrandModel>,
  Brand: Models.Response<TyreParamiterModels.BrandModel>

  ProducerList: Models.ResponseList<TyreParamiterModels.ProducerModel>,
  Producer: Models.Response<TyreParamiterModels.ProducerModel>,

  TyreSupplierOfferList: Models.ResponseList<TyreOfferApiModels.TyreSupplierOfferModel>,
  TyreSupplieList: Models.ResponseList<TyreOfferApiModels.TyreSupplierModel>,
  TyreSupplierOffer: Models.Response<TyreOfferApiModels.TyreSupplierOfferModel>,

  Search: TyreSearchModel,

  TyreCarTypeList: Models.ResponseList<TyreParamiterModels.TyreCarTypesModel>
  TyreCarType: Models.Response<TyreParamiterModels.TyreCarTypesModel>
}

class DictionaryKeys {
  public static readonly TyreStateValuesDictionary = "TyreStateValuesDictionary";
  public static readonly TyrePositionDictionary = "TyrePositionDictionary";
  public static readonly SeasonsDictionaryList = "SeasonsDictionaryList";
  public static readonly TyreSegmentDictionaryList = "TyreSegmentDictionaryList";
  public static readonly TyreCarTypeDictionaryList = "TyreCarTypesDictionary";
}


@State<TyreStateModel>({
  name: 'tyre',
  defaults: {
    SeasonsDictionaryList: null,
    BrandDictionaryList: null,
    TyreCarTypeDictionaryList: null,
    TyreSegmentDictionaryList: null,
    TyreParameters: null,
    TyreAvailableForSaleParameters: null,
    TyrePreviewList: null,
    RimDictionary: null,
    TyreWidthList: null,
    TyreWidth: null,
    TyreHeightList: null,
    TyreHeight: null,
    TyreDiameterList: null,
    TyreDiameter: null,
    TyreConstructionTypeList: null,
    TyreConstructionType: null,
    TyreSpeedIndexeList: null,
    TyreSpeedIndexe: null,
    TyreLoadIndexeList: null,
    TyreLoadIndexe: null,
    TyreReinforcementList: null,
    TyreReinforcements: null,
    BrandList: null,
    Brand: null,
    ProducerList: null,
    Producer: null,
    TyreSupplierOfferList: null,
    TyreSupplieList: null,
    TyreSupplierOffer: null,
    Search: null,
    TyreCarTypeList: null,
    TyreCarType: null
  }
})

@Injectable()

export class TyreState {

  constructor(
    private helperService: HelperService,
    private tyreService: TyreService,
    private bannerService: BannerService,
    private storageService: StorageService
  ) { }

  @Selector()
  static SeasonsDictionaryList(state: TyreStateModel) {
    return state.SeasonsDictionaryList;
  }

  @Selector()
  static BrandDictionary(state: TyreStateModel) {
    return state.BrandDictionaryList;
  }

  @Selector()
  static TyreCarTypeDictionary(state: TyreStateModel) {
    return state.TyreCarTypeDictionaryList;
  }

  @Selector()
  static TyreSegmentDictionary(state: TyreStateModel) {
    return state.TyreSegmentDictionaryList;
  }

  @Selector()
  static TyreParameters(state: TyreStateModel) {
    return state.TyreParameters;
  }

  @Selector()
  static TyreAvailableForSaleParameters(state: TyreStateModel) {
    return state.TyreAvailableForSaleParameters;
  }

  @Selector()
  static TyrePreviewList(state: TyreStateModel) {
    return state.TyrePreviewList;
  }

  @Selector()
  static TyreSupplierOfferList(state: TyreStateModel) {
    return state.TyreSupplierOfferList;
  }


  @Selector()
  static RimDictionary(state: TyreStateModel) {
    return state.RimDictionary;
  }


  @Selector()
  static TyreWidthList(state: TyreStateModel) {
    return state.TyreWidthList;
  }

  @Selector()
  static TyreWidth(state: TyreStateModel) {
    return state.TyreWidth;
  }

  @Selector()
  static TyreHeightList(state: TyreStateModel) {
    return state.TyreHeightList;
  }

  @Selector()
  static TyreHeight(state: TyreStateModel) {
    return state.TyreHeight;
  }

  @Selector()
  static TyreDiameterList(state: TyreStateModel) {
    return state.TyreDiameterList;
  }

  @Selector()
  static TyreDiameter(state: TyreStateModel) {
    return state.TyreDiameter;
  }

  @Selector()
  static TyreConstructionTypeList(state: TyreStateModel) {
    return state.TyreConstructionTypeList;
  }

  @Selector()
  static TyreConstructionType(state: TyreStateModel) {
    return state.TyreConstructionType;
  }

  @Selector()
  static TyreSpeedIndexeList(state: TyreStateModel) {
    return state.TyreSpeedIndexeList;
  }

  @Selector()
  static TyreSpeedIndex(state: TyreStateModel) {
    return state.TyreSpeedIndexe;
  }

  @Selector()
  static TyreLoadIndexeList(state: TyreStateModel) {
    return state.TyreLoadIndexeList;
  }

  @Selector()
  static TyreLoadIndex(state: TyreStateModel) {
    return state.TyreLoadIndexe;
  }

  @Selector()
  static TyreReinforcementList(state: TyreStateModel) {
    return state.TyreReinforcementList;
  }

  @Selector()
  static TyreReinforcement(state: TyreStateModel) {
    return state.TyreReinforcements;
  }

  @Selector()
  static BrandList(state: TyreStateModel) {
    return state.BrandList;
  }

  @Selector()
  static Brand(state: TyreStateModel) {
    return state.Brand;
  }

  @Selector()
  static ProducerList(state: TyreStateModel) {
    return state.ProducerList;
  }

  @Selector()
  static Producer(state: TyreStateModel) {
    return state.Producer;
  }

  @Selector()
  static TyreSupplieList(state: TyreStateModel) {
    return state.TyreSupplieList;
  }

  @Selector()
  static TyreSupplierOffer(state: TyreStateModel) {
    return state.TyreSupplierOffer;
  }

  @Selector()
  static TyreSearch(state: TyreStateModel) {
    return state.Search;
  }

  @Selector()
  static TyreCarTypeList(state: TyreStateModel) {
    return state.TyreCarTypeList;
  }

  @Selector()
  static TyreCarType(state: TyreStateModel) {
    return state.TyreCarType;
  }

  @Action(TyreActions.GetSeasonsDictionary)
  GetSeasonsDictionary(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania listy sezonów opon.';

    let storageKey = DictionaryKeys.SeasonsDictionaryList;

    context.setState(
      patch({
        SeasonsDictionaryList: this.storageService.getItemJSON(storageKey)
      })
    );


    const state = context.getState();

    if (!state.SeasonsDictionaryList) {
      this.tyreService.getSeasonsDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              SeasonsDictionaryList: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {

          this.helperService.SaveException('TyreAction.GetSeasonsDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreActions.GetTyreParameters)
  GetTyreParameters(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania informacji o parametrach opon.';

    const state = context.getState();

    if (!state.TyreParameters) {
      this.tyreService.getTyreParameters().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              TyreParameters: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyreParameters', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreActions.GetTyreAvailableForSaleParameters)
  GetTyreAvailableForSaleParameters(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania informacji o parametrach opon dostępnych do sprzedąży.';

    const state = context.getState();

    if (!state.TyreAvailableForSaleParameters) {
      this.tyreService.getTyreAvailableForSaleParameters().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              TyreAvailableForSaleParameters: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyreAvailableForSaleParameters', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreActions.GetTyreSegmentsDictionary)
  GetTyreSegmentsDictionary(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania informacji o segmentach opon.';

    let storageKey = DictionaryKeys.TyreSegmentDictionaryList;

    context.setState(
      patch({
        TyreSegmentDictionaryList: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.TyreSegmentDictionaryList) {
      this.tyreService.getSegmentsDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              TyreSegmentDictionaryList: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyreSegmentsDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreActions.GetTyreCarTypesDictionary)
  GetTyreCarTypesDictionary(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania informacji o typach samochodów w kontekscie opon.';

    let storageKey = DictionaryKeys.TyreCarTypeDictionaryList;

    context.setState(
      patch({
        TyreCarTypeDictionaryList: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.TyreCarTypeDictionaryList) {
      this.tyreService.getTyreCarTypesDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              TyreCarTypeDictionaryList: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyreCarTypesDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreActions.GetBrandsDictionary)
  GetBrandsDictionary(
    context: StateContext<TyreStateModel>
  ) {

    let errorMessage = 'Błąd pobierania informacji o markach opon.';

    const state = context.getState();

    if (!state.BrandDictionaryList) {
      this.tyreService.getBrandDictionary().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              BrandDictionaryList: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyreCarTypesDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreActions.GetListSold)
  GetListSold(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetListSold
  ) {

    const errorMessage = 'Błąd pobierania listy opon w sprzedaży.';

    context.setState(
      patch({
        TyrePreviewList: null
      })
    );

    this.tyreService.getListSold(action.search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            TyrePreviewList: ret
          })
        );

        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('TyreAction.GetListSold', error);

        this.bannerService.error(errorMessage);
      });

  }

  @Action(TyreActions.GetListReseling)
  GetListReseling(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetListSold
  ) {

    const errorMessage = 'Błąd pobierania listy opon w sprzedaży.';

    context.setState(
      patch({
        TyrePreviewList: null
      })
    );

    this.tyreService.getListReseling(action.search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            TyrePreviewList: ret
          })
        );

        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('TyreAction.GetListReseling', error);

        this.bannerService.error(errorMessage);
      });

  }


  @Action(TyreActions.GetList)
  GetList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetListSold
  ) {

    const errorMessage = 'Błąd pobierania listy opon.';

    context.setState(
      patch({
        TyrePreviewList: null
      })
    );

    this.tyreService.getList(action.search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            TyrePreviewList: ret
          })
        );

        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('TyreAction.GetList', error);

        this.bannerService.error(errorMessage);
      });

  }


  @Action(TyreActions.GetRimDictionary)
  GetRimDictionary(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetRimDictionary
  ) {

    let errorMessage = 'Błąd pobierania listy dostępnych felg.';

    context.setState(
      patch({
        RimDictionary: null
      })
    );

    this.tyreService.getRimDictionary().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            RimDictionary: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('TyreAction.GetRimDictionary', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreActions.GetTyreSupplierOffers)
  GetTyreSupplierOffers(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreSupplierOffers
  ) {
    const errorMessage = 'Błąd pobierania listy ofert.';

    this.tyreService.getTyreSupplierOffers(action.Tyre).subscribe(
      ret => {
        context.setState(
          patch({
            TyreSupplierOfferList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreSupplierOffers', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetOffers)
  GetOffers(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetOffers
  ) {
    const errorMessage = 'Błąd pobierania szczegółów oferty.';

    this.tyreService.getTyreSupplierOffer(action.TyreSupplierOffer).subscribe(
      ret => {
        context.setState(
          patch({
            TyreSupplierOffer: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreSupplierOffer', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreWidthList)
  GetTyreWidthsList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreWidthList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreWidthsList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreWidthList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreWidthsList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreHeightList)
  GetTyreHeightsList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreHeightList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreHeightsList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreHeightList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreHeightsList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreDiameterList)
  GetTyreDiametersList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreDiameterList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreDiametersList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreDiameterList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreDiametersList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreConstructionTypeList)
  GetTyreConstructionTypesList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreConstructionTypeList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreConstructionTypesList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreConstructionTypeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreConstructionTypesList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreSpeedIndexList)
  GetTyreSpeedIndexesList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreSpeedIndexList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreSpeedIndexesList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreSpeedIndexeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreSpeedIndexesList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreLoadIndexList)
  GetTyreLoadIndexesList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreLoadIndexList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreLoadIndexesList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreLoadIndexeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreLoadIndexesList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreReinforcementList)
  GetTyreReinforcementsList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreReinforcementList
  ) {
    const errorMessage = 'Błąd pobierania listy parametrów.';

    this.tyreService.getTyreReinforcementsList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreReinforcementList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreReinforcementsList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetBrandList)
  GetBrandList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetBrandList
  ) {
    const errorMessage = 'Błąd pobierania listy marek opon.';

    this.tyreService.getBrandList().subscribe(
      ret => {
        context.setState(
          patch({
            BrandList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetBrandList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetProducerList)
  GetProducerList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetProducerList
  ) {
    const errorMessage = 'Błąd pobierania listy marek opon.';

    this.tyreService.getProducerList().subscribe(
      ret => {
        context.setState(
          patch({
            ProducerList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetProducerList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreCarTypeList)
  GetTyreCarTypeList(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetTyreCarTypeList
  ) {
    const errorMessage = 'Błąd pobierania listy typów nadwozia opon.';

    this.tyreService.getTyreCarTypeList().subscribe(
      ret => {
        context.setState(
          patch({
            TyreCarTypeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreCarTypeList', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetTyreWidth)
  SetTyreWidth(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetTyreWidth
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreWidth: null
      })
    );

    this.tyreService.setTyreWidth(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreWidth: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetTyreWidth', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetTyreHeight)
  SetTyreHeight(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetTyreHeight
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreHeight: null
      })
    );

    this.tyreService.setTyreHeight(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreHeight: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetTyreHeight', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetTyreDiameter)
  SetTyreDiameter(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetTyreDiameter
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreDiameter: null
      })
    );

    this.tyreService.setTyreDiameter(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreDiameter: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetTyreDiameter', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetTyreConstructionType)
  SetTyreConstructionType(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetTyreConstructionType
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreConstructionType: null
      })
    );

    this.tyreService.setTyreConstructionType(action.Value).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreConstructionType: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetTyreConstructionType', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetSpeedIndex)
  SetSpeedIndex(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetSpeedIndex
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreSpeedIndexe: null
      })
    );

    this.tyreService.setSpeedIndex(action.Value).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreSpeedIndexe: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetSpeedIndex', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetLoadIndex)
  SetLoadIndex(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetLoadIndex
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreLoadIndexe: null
      })
    );

    this.tyreService.setLoadIndex(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreLoadIndexe: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetLoadIndex', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetReinforcement)
  SetReinforcement(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetReinforcement
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreReinforcements: null
      })
    );

    this.tyreService.setReinforcement(action.Value).subscribe(
      ret => {
        if (ret.Success) {
          this.bannerService.success('Dodano nowy parametr.');

          context.setState(
            patch({
              TyreReinforcements: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetReinforcement', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetProducer)
  SetProucer(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetProducer
  ) {
    const errorMessage = 'Błąd zapisu producenta.';

    context.setState(
      patch({
        TyreReinforcements: null
      })
    );

    this.tyreService.setProducer(action.Value).subscribe(
      ret => {
        if (ret.Success) {
          this.bannerService.success('Zapisano dane producenta.');

          context.setState(
            patch({
              Producer: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetProucer', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.SetBrand)
  SetBrand(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetBrand
  ) {
    const errorMessage = 'Błąd zapisu marki.';

    context.setState(
      patch({
        TyreReinforcements: null
      })
    );

    this.tyreService.setBrand(action.Value).subscribe(
      ret => {
        if (ret.Success) {
          this.bannerService.success('Zapisano dane marki.');

          context.setState(
            patch({
              Brand: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetBrand', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }


  @Action(TyreActions.DeleteTyreWidth)
  DeleteTyreWidth(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteTyreWidth
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreWidth: null
      })
    );

    this.tyreService.deleteTyreWidth(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreWidth: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteTyreWidth', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.DeleteTyreHeight)
  DeleteTyreHeight(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteTyreHeight
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreHeight: null
      })
    );

    this.tyreService.deleteTyreHeight(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreHeight: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteTyreHeight', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.DeleteTyreDiameter)
  DeleteTyreDiameter(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteTyreDiameter
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreDiameter: null
      })
    );

    this.tyreService.deleteTyreDiameter(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreDiameter: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteTyreDiameter', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.DeleteTyreConstructionType)
  DeleteTyreConstructionType(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteTyreConstructionType
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreConstructionType: null
      })
    );

    this.tyreService.deleteTyreConstructionType(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreConstructionType: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteTyreConstructionType', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.DeleteSpeedIndex)
  DeleteSpeedIndex(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteSpeedIndex
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreSpeedIndexe: null
      })
    );

    this.tyreService.deleteSpeedIndex(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreSpeedIndexe: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteSpeedIndex', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.DeleteLoadIndex)
  DeleteLoadIndex(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteLoadIndex
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreLoadIndexe: null
      })
    );

    this.tyreService.deleteLoadIndex(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreLoadIndexe: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteLoadIndex', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.DeleteReinforcement)
  DeleteReinforcement(
    context: StateContext<TyreStateModel>,
    action: TyreActions.DeleteReinforcement
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreReinforcements: null
      })
    );

    this.tyreService.deleteReinforcement(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Usunięto wybraną watość.');

          context.setState(
            patch({
              TyreReinforcements: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.DeleteReinforcement', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }


  @Action(TyreActions.MergeTyreWidth)
  MergeTyreWidth(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeTyreWidth
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreWidthList: null
      }));


    this.tyreService.mergeTyreWidth(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            TyreWidthList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeTyreWidth', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.MergeTyreHeight)
  MergeTyreHeight(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeTyreHeight
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreHeightList: null
      }));


    this.tyreService.mergeTyreHeight(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            TyreHeightList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeTyreHeight', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.MergeTyreDiameter)
  MergeTyreDiameter(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeTyreDiameter
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreDiameterList: null
      }));

    this.tyreService.mergeTyreDiameter(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            TyreDiameterList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeTyreDiameter', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.MergeTyreConstructionType)
  MergeTyreConstructionType(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeTyreConstructionType
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreConstructionTypeList: null
      }));

    this.tyreService.mergeTyreConstructionType(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            TyreConstructionTypeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeTyreConstructionType', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.MergeSpeedIndex)
  MergeSpeedIndex(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeSpeedIndex
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreSpeedIndexeList: null
      }));

    this.tyreService.mergeSpeedIndex(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            TyreSpeedIndexeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeSpeedIndex', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.MergeLoadIndex)
  MergeLoadIndex(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeLoadIndex
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreLoadIndexeList: null
      }));

    this.tyreService.mergeLoadIndex(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            TyreLoadIndexeList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeLoadIndex', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.MergeReinforcement)
  MergeReinforcement(
    context: StateContext<TyreStateModel>,
    action: TyreActions.MergeReinforcement
  ) {
    const errorMessage = 'Błąd łączenia wartości.';

    context.setState(
      patch({
        TyreReinforcementList: null
      }));

    this.tyreService.mergeReinforcement(action.Value).subscribe(

      ret => {

        if (ret.Success) {
          this.bannerService.success("Połączono wartości");
        }
        else {
          this.bannerService.error(ret.Message);
        }


        context.setState(
          patch({
            TyreReinforcementList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.MergeReinforcement', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.GetTyreSuppliers)
  GetTyreSuppliers(
    context: StateContext<TyreStateModel>,
    action: TyreActions.GetProducerList
  ) {
    const errorMessage = 'Błąd pobierania listy dostawców opon.';

    this.tyreService.getTyreSuppliers().subscribe(
      ret => {
        context.setState(
          patch({
            TyreSupplieList: ret
          }));
      },

      (error) => {
        this.helperService.SaveException('TyreAction.GetTyreSuppliers', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }



  @Action(TyreActions.SetSearch)
  SetSearch(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    if (action.Search.IsOnPriceList) {
      context.dispatch(new TyreActions.GetListSold(action.Search));
    }
    else {
      context.dispatch(new TyreActions.GetList(action.Search));
    }
  }

  @Action(TyreActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreStateModel>
  ) {

    const state = context.getState();

    const search = new TyreSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreActions.GetList(search));
  }

  @Action(TyreActions.ResetSearchOnPriceList)
  ResetSearchOnPriceList(
    context: StateContext<TyreStateModel>
  ) {

    const state = context.getState();

    const search = new TyreSearchModel();

    search.IsOnPriceList = true;
    search.IsActive = true;
    search.IsPagination = true;
    search.HasTyreSupplierOffer = true;

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreActions.GetListSold(search));
  }


  @Action(TyreActions.DisposeSearch)
  DisposeSearch(
    context: StateContext<TyreStateModel>
  ) {

    context.setState(
      patch({
        Search: null
      }));
  }

  @Action(TyreActions.SetListPage)
  SetListPage(
    context: StateContext<TyreStateModel>,
    action: TyreActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    if (action.Search.IsOnPriceList) {
      context.dispatch(new TyreActions.GetListSold(action.Search));
    }
    else {
      context.dispatch(new TyreActions.GetList(action.Search));
    }
  }


  @Action(TyreActions.UpdateTyreDiameter)
  UpdateTyreDiameter(
    context: StateContext<TyreStateModel>,
    action: TyreActions.UpdateTyreDiameter
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreDiameter: null
      })
    );

    this.tyreService.updateTyreDiameter(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zaktuaklizowano wybraną watość.');

          context.setState(
            patch({
              TyreDiameter: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.UpdateTyreDiameter', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreActions.UpdateTyreCarType)
  UpdateTyreCarType(
    context: StateContext<TyreStateModel>,
    action: TyreActions.UpdateTyreCarType
  ) {
    const errorMessage = 'Błąd zapisu parametru.';

    context.setState(
      patch({
        TyreDiameter: null
      })
    );

    this.tyreService.updateTyreCarType(action.Value).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zaktualizowano wybraną wartość.');

          context.setState(
            patch({
              TyreCarType: ret
            }));
        }
        else {
          this.bannerService.error(ret.Message);
        }
      },

      (error) => {
        this.helperService.SaveException('TyreAction.UpdateTyreCarType', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}

